import z from "zod/v4";
import { isoDate, type ISODate } from "./isoDate";

export const isoDatetime = z.iso.datetime().brand("ISODatetime");
export type ISODatetime = z.output<typeof isoDatetime>;

export function isoDatetimeToIsoDate(datetime: ISODatetime): ISODate {
  return isoDate.parse(datetime.split("T")[0]);
}
